import type { UserType } from "@/types"
import Cookies from "js-cookie"

import { env } from "@/env"

// import { refreshAccessToken } from "./api/auth"
import { apiFetch } from "./utils"

export function saveAuth(user: UserType) {
  const userInfo = {
    full_name: user.user_info.full_name,
    email: user.user_info.email,
    user_group: user.user_info.user_group,
    username: user.user_info.username,
    is_mfa_enabled: user.user_info.is_mfa_enabled,
    user_id: user.user_info.user_id,
    mobile_number: user.user_info.mobile_number,
    address: user.user_info.address,
    client_id: user.client_info.client_id,
  }

  // ❌ TANGGALIN ANG MGA SUMUSUNOD NA LINYA (huwag nang mag-set ng token cookies)
  // Cookies.set("auth-token", user.user_info.token, { expires: 1 / 48 })
  // Cookies.set("refresh-token", user.user_info.refresh_token, { expires: 1 })

  // ✅ Ang mga sumusunod ay panatilihin (user info cookies)
  Cookies.set("user_client_info", JSON.stringify(user.client_info), {
    expires: (1 / 1440) * env.SESSION_DURATION,
  })
  Cookies.set("user_id", user.user_info.user_id, {
    expires: (1 / 1440) * env.SESSION_DURATION,
  })
  Cookies.set("user_info", JSON.stringify(userInfo), {
    expires: (1 / 1440) * env.SESSION_DURATION,
  })
  Cookies.set("is_mfa_enabled", String(user.user_info.is_mfa_enabled), {
    expires: (1 / 1440) * env.SESSION_DURATION,
  })
  Cookies.set(
    "is_unknown_device_enabled",
    String(user.user_info.is_unknown_device_enabled),
    { expires: (1 / 1440) * env.SESSION_DURATION },
  )
  Cookies.set(
    "is_himo_assistant_enabled",
    String(user.client_info.is_himo_assistant_enabled),
    { expires: (1 / 1440) * env.SESSION_DURATION },
  )

  // ✅ Store permissions with fallback
  const permissions = user.user_info.user_permissions || []
  localStorage.setItem("user_permissions", JSON.stringify(permissions))
  // console.log("Permissions saved:", permissions)
}
export function getUserPermissions(): string[] {
  const perms = localStorage.getItem("user_permissions")
  try {
    return perms ? JSON.parse(perms) : []
  } catch {
    return []
  }
}
export async function isAuthenticated(): Promise<boolean> {
  try {
    // Tawagin ang endpoint na nangangailangan ng authentication
    const res = await apiFetch("user/me/", { method: "GET" }, true) // skipAuth para iwas redirect loop
    return res.ok
  } catch {
    return false
  }
}

export function isHimoAssistantEnabled() {
  // return Cookies.get("is_himo_assistant_enabled") === "true"
  return true
}
export function getAuthToken() {
  const token = Cookies.get("auth-token")
  return token
}

export function getRefreshToken() {
  const token = Cookies.get("refresh-token")
  return token
}

export function getClientId() {
  const client = Cookies.get("user_client_info") || "{}"
  return JSON.parse(client).client_id
}

export function getUserEmail() {
  const userInfo = Cookies.get("user_info") || "{}"
  return JSON.parse(userInfo).email
}
export function getFullName() {
  const userInfo = Cookies.get("user_info") || "{}"
  return JSON.parse(userInfo).full_name
}

export function isMfaEnabled() {
  return Cookies.get("is_mfa_enabled") === "true"
}
export function isUnknownDeviceEnabled() {
  return Cookies.get("is_unknown_device_enabled") === "true"
}

export function getUserId() {
  const userInfo = Cookies.get("user_info") || "{}"
  return JSON.parse(userInfo).user_id
}

export function logout() {
  // Tawagin ang backend logout para burahin ang HTTP-only cookies
  apiFetch("logout/", { method: "POST" }).finally(() => {
    // Burahin ang client-side cookies at storage
    Cookies.remove("user_client_info")
    Cookies.remove("user_id")
    Cookies.remove("user_info")
    Cookies.remove("is_mfa_enabled")
    Cookies.remove("is_unknown_device_enabled")
    Cookies.remove("is_himo_assistant_enabled")
    localStorage.removeItem("user_permissions")
    const email = getUserEmail()
    localStorage.removeItem(`device_trusted-${email}`)
    Cookies.remove(`mfa-auth-${email}`)
    window.location.href = "/login"
  })
}
